import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Homepage from './pages/Homepage';
import Services from './pages/Services';
import Contact from './pages/Contact';
import About from './pages/About';
import WaterSoftener from './pages/WaterSoftener';
import ReverseOsmosis from './pages/ReverseOsmosis';
import BoilerWaterTreatment from './pages/BoilerWaterTreatment';
import CoolingTowerTreatment from './pages/CoolingTowerTreatment';
import EffluentTreatment from './pages/EffluentTreatment';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/water-softener" element={<WaterSoftener />} />
          <Route path="/reverse-osmosis" element={<ReverseOsmosis />} />
          <Route path="/boiler-water-treatment" element={<BoilerWaterTreatment />} />
          <Route path="/cooling-tower-treatment" element={<CoolingTowerTreatment />} />
          <Route path="/effluent-treatment" element={<EffluentTreatment />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
